
import mixins from 'vue-typed-mixins'
import ScreenMixin from "@/mixins/ScreenMixin";
export default mixins(ScreenMixin).extend({
  name: 'PageNotFound',
  computed: {
    imgWidth(): number{
      return this.xsScreen ? 366 : 489;
    },
    imgHeight(): number{
      return this.xsScreen ? 427 : 570;
    }
  }
})
